export const ROLE_ADMIN = 'admin';
export const ROLE_CHIEF_EDITORIAL = 'chief';
export const ROLE_EDITORIAL = 'editorial';
export const ROLE_EDITORIAL_BOARD = 'board_member';
export const ROLE_AUTHOR = 'author';
export const ROLE_REVIEWER = 'reviewer';
export const ROLE_EDITOR = 'editor';
export const ROLE_ACCOUNTANT = 'accountant';

export const ROLES_HAS_JOURNAL = [ROLE_EDITORIAL, ROLE_EDITORIAL_BOARD, ROLE_EDITOR, ROLE_REVIEWER, ROLE_ACCOUNTANT];



// WEBPACK FOOTER //
// ./src/constants/roles.js